import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function Hospitality() {
 useEffect(() => {
   window.scrollTo(0, 0);
 }, []);
  return (
      <>
          <Helmet>
                <title>Expert Software Development Services for Your Business-Taskflier</title>
                    </Helmet>
          
                        <div class="block-style-thirtySix bg-white lg-container pt-110  pb-80" id="feature">
                            <div class="container">
                                <div class="row">
                                    <div class="col-xl-6 col-lg-7   aos-animate" data-aos="fade-left">
                                        <div class="pl-lg-5">
                                            <div class="title-style-fourteen">
                                                <h6><span class="upper-title custom-name">Hospitality Solutions by Taskflier</span></h6>
                                                <h1>Smart Management for Exceptional Guest Experiences</h1>
                                            </div>
                                            <div class="tag-line">In the hospitality industry, delivering a seamless and memorable guest experience is the key to success. From reservations and daily operations to service requests and staff coordination, every process must run smoothly. Taskflier is a powerful hospitality management solution designed to help hotels, resorts, restaurants, and hospitality service providers manage operations efficiently while maintaining high service standards.
                                            </div>
                                            <Link class="theme-btn-2 mt-10 md-mt-30" to="/demo-request">Request Demo <i class="bi bi-arrow-right pl-2"></i></Link>
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-5 text-center text-lg-left   aos-animate" data-aos="fade-right">
                                        <div class="illustration-holder d-inline-block md-mt-60">
                                            <img src="/main/images/hotels.png" alt="Construction Management Software" className='w-100' />
                                            {/* <img src="/images/assets/ils_23.1.svg" alt="" class="shapes shape-one" />
                                            <img src="/images/assets/ils_23.2.svg" alt="" class="shapes shape-two" />
                                            <img src="/images/assets/ils_23.3.svg" alt="" class="shapes shape-three" /> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
          
          <div class="fancy-feature-ten pt-80 pb-100 bg-white" id="feature">
				  <div class="bg-wrapper pt-80">
					<div class="container">
					  
					<div class="row align-items-center">
		   
		   <div class="col-lg-5 aos-init aos-animate">
			 <div class="text-wrapper">
			 
			 <h3 class="maintitle">Why Taskflier for Hospitality Businesses?
							   </h3>
							
							   
	  
	  <p className="mainp">
	Hospitality operations involve multiple departments working together in real time. Without proper coordination, service delays and operational errors can impact guest satisfaction. Taskflier solves these challenges by centralizing all activities into a single system.
	  </p>
      <ul class="bullet">
<li>Centralized management for all departments</li>
<li>Faster response to guest requests</li>
<li>Improved team coordination and accountability</li>
<li>Reduced manual follow-ups and errors</li>
<li>Consistent service quality across operations</li>
       </ul>
		   
			 </div>
		   </div>
		   
		   <div class="col-lg-6 offset-lg-1">
			 <div
			   class="screen-holder-two aos-init aos-animate"
			   data-aos="fade-left"
			   data-aos-duration="1200"
			 >
			   <img src="/main/images/hotel-Use.png" alt="Construction Management Software" />
			 </div>
		   </div>
		   
		   
		   </div>
		   
					 
					</div>
					<img src="/images/shape/137.svg" alt="shapes" class="shapes shape-one"/>
				  </div> 
		</div>
          
                        <div class="fancy-feature-thirtyFour pt-80 pb-100 bg-gray">
                            <div class="container">
                                <div class="title-style-two text-center mb-40 md-mb-40">
                                    <h6><span class="upper-title custom-name">Explore Taskflier Features!</span></h6>
          
          
                                    <div class="sub-text mt-0 pt-3 maxsubtitle">Frequent difficulties encountered in the software sector.
                                        Obstacles are a part of every project. But which ones affect software development?
                                    </div>
                                </div>
          
                                <div class="row  features">
          
          
                                    <div class="col-lg-4 col-12 ">
          
                                        <div class="Solutions-box " >
                                            <img src="/main/images/hotel6.png" alt="Task creation" class="w-100" />
                                            <div class="pack-name mt-3 text-capitalize">Guest & Client Relationship Management </div>
                                            <hr></hr>
                                            <p className="mainp">Taskflier stores guest details, preferences, and service history in one place, helping hospitality businesses deliver personalized experiences, improve client relationships, and increase repeat visits.</p>
          
          
                                        </div>
          
                                    </div>
                                    <div class="col-lg-4 col-12 ">
          
                                        <div class="Solutions-box " >
                                            <img src="/main/images/hotel7.png" alt="Customizing taskboard" class="w-100" />
                                            <div class="pack-name mt-3 text-capitalize">Task & Workflow Management
                                            </div>
                                            <hr></hr>
                                            <p className="mainp">Taskflier organizes daily hospitality tasks with clear workflows, real-time tracking, and timely execution, ensuring housekeeping, maintenance, and service operations run smoothly without delays.</p>
          
                                        </div>
          
                                    </div>
                                    <div class="col-lg-4 col-12 ">
          
                                        <div class="Solutions-box " >
                                            <img src="/main/images/hotel8.png" alt="Task dependencies" class="w-100" />
                                            <div class="pack-name mt-3 text-capitalize">Front Desk & Operations Coordination</div>
                                            <hr></hr>
                                            <p className="mainp">Taskflier connects the front desk with internal teams, enabling quick logging, tracking, and resolution of guest requests, resulting in faster responses and improved guest satisfaction.</p>
          
          
                                        </div>
                                    </div>
          
                                    <div class="col-lg-4 col-12 ">
          
                                        <div class="Solutions-box " >
                                            <img src="/main/images/hotel9.png" alt="Task creation" class="w-100" />
                                            <div class="pack-name mt-3 text-capitalize">Housekeeping & Maintenance Management</div>
                                            <hr></hr>
                                            <p className="mainp">Taskflier helps manage cleaning schedules, room status, inspections, and maintenance requests efficiently, ensuring consistent cleanliness standards and timely resolution of facility issues.</p>
          
          
                                        </div>
          
                                    </div>
                                    <div class="col-lg-4 col-12 ">
          
                                        <div class="Solutions-box " >
                                            <img src="/main/images/hotel10.png" alt="Customizing taskboard" class="w-100" />
                                            <div class="pack-name mt-3 text-capitalize">Event, Banquet & Catering Management
                                            </div>
                                            <hr></hr>
                                            <p className="mainp">Taskflier simplifies event planning and execution by organizing tasks, timelines, and responsibilities, ensuring smooth coordination, professional delivery, and successful hospitality events.</p>
          
                                        </div>
          
                                    </div>
                                    <div class="col-lg-4 col-12 ">
          
                                        <div class="Solutions-box " >
                                            <img src="/main/images/hotel11.png" alt="Task dependencies" class="w-100" />
                                            <div class="pack-name mt-3 text-capitalize">Automation for Faster Operations
                                            </div>
                                            <hr></hr>
                                            <p className="mainp">Taskflier automates reminders, notifications, and workflow updates, reducing manual effort and helping hospitality teams complete tasks faster and focus more on guest service.</p>
          
                                        </div>
                                    </div>
          
                                </div>
                            </div>
                        </div>
          
          
          
                        <div className="clearfix"></div>
                        <div class="fancy-feature-thirtyTwo pt-100 pb-30  bg-white">
                            <div class="container">
          
                                <div class="row  features">
                                    <div class="col-lg-6  ">
                                        <div
                                            class="screen-holder-two sidesticky">
                                            <div class="title-style-two text-center mb-40 md-mb-40">
                                                <h3 className='maintitle text-left'>
                                                    <span>
                                                        Why do you need TaskFlier?
          
                                                    </span>
                                                </h3>
                                                <div class="sub-text mt-0 pt-1 maxsubtitle text-left">TaskFlier helps hospitality businesses stay organized, responsive, and guest-focused while reducing operational stress.</div>
                                                {/* <div class="sub-text mt-15 maxsubtitle">
                                             Taskflier's top-rated human resource software integrates perfectly with important applications such as
                                             </div> */}
                                            </div>
                                            <img src="/main/images/hotel5.png" alt="" className='img-fluid' />
                                        </div>
                                    </div>
          
          
                                    <div className="col-md-6">
          
                                        <div class="choose-right-wrapper Benefits-realestate ">
                                            <div class="featured-box mb-35">
                                                <div class="icon"><i class="bi bi-shield-check"></i></div>
                                                <div class="content">
                                                    <h4>Centralized Operations Management</h4>
                                                    <p>TaskFlier brings all departments onto one platform, ensuring tasks, updates, and responsibilities are visible and managed from a single dashboard.
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="featured-box mb-35">
                                                <div class="icon"><i class="bi bi-code-slash"></i></div>
                                                <div class="content">
                                                    <h4>Faster Guest Request Handling</h4>
                                                    <p class="mainp">Guest requests can be logged instantly and assigned to the right team, reducing response time and improving guest satisfaction.</p>
                                                </div>
                                            </div>
                                            <div class="featured-box mb-35">
                                                <div class="icon"><i class="bi bi-file-earmark-bar-graph"></i></div>
                                                <div class="content">
                                                    <h4>Real-Time Reports & Insights</h4>
                                                    <p class="mainp">Managers gain visibility into task completion, response times, staff performance, and departmental efficiency for better decision-making.
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="featured-box mb-35">
                                                <div class="icon"><i class="bi bi-headset"></i></div>
                                                <div class="content">
                                                    <h4>Secure & Cloud-Based Access</h4>
                                                    <p class="mainp">Teams can access the system anytime, anywhere, with role-based permissions and secure data handling.</p>
                                                </div>
                                            </div>
                                           
                                        </div>
          
                                    </div>
          
          
                                </div>
                            </div>
                        </div>
          
                        <div class="client-feedback-slider-eight lg-container upcoming pt-20 pb-80" id="feedback">
                            <div class="container">
                                <div class="main-content position-relative">
                                    <div class="row align-items-center justify-content-between">
                                        <div class="col-lg-8 col-md-8 m-auto text-center">
                                            <div class="feedback-wrapper py-5">
          
                                                <h2 class="maintitle text-white"><span>Expanded Benefits of TaskFlier for Hospitality</span></h2>
          
                                                <div class="sub-text mt-0 pt-0  maxsubtitle text-white">In any software project, There has to be a structured approach known as the project management process. An effective software project management approach goes as follows:</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row  features flip-card">
                                        <div class="col-lg-3 col-12 ">
          
                                            <div class="Solutions-box " >
          
                                                <div class="flip-card-inner">
                                                    <div class="flip-card-front">
                                                        <div class="pack-name  text-capitalize">Faster Service Delivery
                                                        </div>
                                                        <hr></hr>
                                                        <p className="font-14 text-white">Guest requests are instantly converted into actionable tasks and assigned to the right team, ensuring quick and professional service delivery.</p>
          
                                                        <div>
          
          
                                                        </div>
          
                                                    </div>
                                                    <div class="flip-card-back">
                                                        <div class="pack-name  text-dark text-capitalize">Faster Service Delivery
                                                        </div>
                                                        <hr></hr>
                                                        <ul className='mainp bullet text-muted'>
                                                         <li> Faster response to guest requests</li>
                                                         <li> Real-time task status tracking</li>
                                                         <li> Reduced guest waiting time</li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                </div>
          
                                        </div>
                                        <div class="col-lg-3 col-12 ">
          
                                            <div class="Solutions-box " >
          
                                                <div class="flip-card-inner">
                                                    <div class="flip-card-front">
                                                        <div class="pack-name  text-capitalize">Better Housekeeping & Room Readiness</div>
                                                        <hr></hr>
                                                        <p className="font-14 text-white">Cleaning schedules, inspections, and room status updates are organized digitally, ensuring rooms are always guest-ready.</p>
          
                                                        <div>
          
          
                                                        </div>
          
                                                    </div>
                                                    <div class="flip-card-back">
                                                        <div class="pack-name  text-dark text-capitalize">Better Housekeeping & Room Readiness
                                                        </div>
                                                        <hr></hr>
                                                        <ul className='mainp bullet text-muted'>
<li>Digital housekeeping schedules</li>
<li>Real-time room status updates</li>
<li>Consistent cleanliness standards</li>
          </ul>
                                                    </div>
                                                </div>
          
          
          
          
                                            </div>
                                        </div>
          
                                        <div class="col-lg-3 col-12 ">
          
                                            <div class="Solutions-box " >
          
                                                <div class="flip-card-inner">
                                                    <div class="flip-card-front">
                                                        <div class="pack-name  text-capitalize">Strong Maintenance Management</div>
                                                        <hr></hr>
                                                        <p className="font-14 text-white ">Maintenance issues are logged, prioritized, and tracked until closure, preventing service disruptions and repeat complaints.
                                                        </p>
                                                        <div>
          
          
                                                        </div>
                                                    </div>
                                                    <div class="flip-card-back">
                                                        <div class="pack-name text-dark  text-capitalize">Strong Maintenance Management
                                                        </div>
                                                        <hr></hr>
                                                        <ul className='mainp bullet text-muted'>
                                                         <li>Centralized issue reporting</li>
                                                         <li>Priority-based task assignment</li>
                                                         <li>Faster issue resolution</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
          
                                        </div>
                                        <div class="col-lg-3 col-12 ">
          
                                            <div class="Solutions-box " >
          
                                                <div class="flip-card-inner">
                                                    <div class="flip-card-front">
                                                        <div class="pack-name  text-capitalize">Clear Staff Responsibilities
                                                        </div>
                                                        <hr></hr>
                                                        <p className="font-14 text-white">Every task is assigned with a clear owner and deadline, improving accountability and operational discipline.</p>
                                                        <div></div>
                                                    </div>
                                                    <div class="flip-card-back">
                                                        <div class="pack-name text-dark  text-capitalize">Clear Staff Responsibilities
                                                        </div>
                                                        <hr></hr>
                                                        <ul className='mainp bullet text-muted'>
                                                            <li>Defined task ownership</li>
                                                            <li>Clear priorities and timelines</li>
                                                            <li>Reduced confusion among staff</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-12 ">
                                            <div class="Solutions-box " >
                                                <div class="flip-card-inner">
                                                    <div class="flip-card-front">
                                                        <div class="pack-name  text-capitalize">Secure Cloud-Based Access
                                                        </div>
                                                        <hr></hr>
                                                        <p className="font-14 text-white">Hospitality teams can access TaskFlier from anywhere while management controls permissions and data security.</p>
                                                        <div>
                                                        </div>
                                                    </div>
                                                    <div class="flip-card-back">
                                                        <div class="pack-name  text-dark text-capitalize">Secure Cloud-Based Access
                                                        </div>
                                                        <hr></hr>
          <ul className='mainp bullet text-muted'>
          <li>Cloud-based access</li>
          <li>Role-based permissions</li>
          <li>Secure data management</li>
          </ul>
          
                                                    </div>
                                                </div>
          
          
          
          
          
                                            </div>
          
          
                                        </div>
                                        <div class="col-lg-9 col-12 ">
          
                                            <div class="Solutions-box " >
          
                                            </div>
          
                                        </div>
          
                                    </div>
          
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="d-sm-flex align-items-center justify-content-center button-group mt-4"><button type="button" data-bs-toggle="modal" data-bs-target="#request-for-free-trial" class="btn-trial  btn-primary mt-10 fw-500  font-13 mb-0"><span>Start your free trial</span> <i class="bi bi-stopwatch font-16"></i></button></div>
                                            <div className='text-center'><small class="text-white text-center font-11">No credit card required</small></div>
                                        </div>
                                    </div>
          
                                </div>
                            </div>
                        </div>
          
                        
          
                 <div class="fancy-feature-ten pt-80  bg-white" id="feature">
                      <div class="bg-wrapper pt-80">
                        <div class="container">
                          
                        <div class="row align-items-center">
               
               <div class="col-lg-6 ">
                 <div
                   class="screen-holder-two aos-init aos-animate"
                   data-aos="fade-left"
                   data-aos-duration="1200"
                 >
                   <img src="/main/images/hotel3.png" alt="Employee Lifecycle" />
                 </div>
               </div>
          
              <div class="col-lg-5 offset-lg-1 aos-init aos-animate">
                 <div class="text-wrapper">
                 
                   <h3 class="maintitle">How TaskFlier Enhances Guest Experience</h3>
                   <p className="mainp">
                  TaskFlier improves the overall guest journey by ensuring that every request, service, and interaction is handled quickly and professionally. By streamlining internal operations, it allows hospitality teams to focus more on guest comfort and satisfaction rather than operational challenges.
                 </p> 
               
               <ul className='bullet'> 
                <li>Reduced waiting time for services through faster task assignment</li> 
                <li>Faster issue resolution with real-time tracking and alerts</li> 
                <li>Cleaner rooms and well-maintained facilities at all times</li> 
                <li>More personalized guest interactions using organized guest data</li> 
                <li>Consistent service standards across departments and shifts</li> 
                <li>Smooth coordination between front desk and service teams</li> 
               
                </ul>
          
          
                 </div>
               </div>
               
               </div>
               
                         
                        </div>
                        <img src="/images/shape/137.svg" alt="shapes" class="shapes shape-one"/>
                      </div> 
                    </div>
          <div class="fancy-feature-thirtyTwo pt-100 pb-30  bg-white">
                            <div class="container">
                                
                                <div class="row align-items-center">
                                    <div class="col-lg-5 aos-init aos-animate" data-aos="fade-right">
                                        <div class="title-style-eleven">
                                            
                                        
                            <h3 class="maintitle">Long-Term Value with TaskFlier</h3>
                                        </div>
                                        <p className='mainp mb-10'>TaskFlier is not just a task management tool—it is a complete hospitality operations system. It helps businesses standardize processes, reduce operational risks, and deliver consistently high-quality service. Over time, this leads to better guest reviews, higher repeat bookings, improved staff retention, and sustainable business growth.
          </p>

                                        <ul className='bullet'> 
                                        <li>Standardized processes that ensure consistent service delivery</li> 
                                        <li>Reduced operational errors and service gaps over time</li> 
                                        <li>Higher guest satisfaction leading to better online reviews</li> 
                                        <li>Increased repeat bookings and long-term guest loyalty</li> 
                                        <li>Better staff retention through clear roles and reduced stress</li> 
                                        <li>Scalable system that grows with your hospitality business</li> 
                                        
                                        </ul>
          {/* <p className='mainp mb-10'>Are you set to get the most from your project working endeavors? If so, we encourage you to truly use our project management application software and discover the goodness of project management software developed specifically to suit your business needs!
          </p> */}
          
                                        
                                    </div>
                                    <div class="col-xl-6 col-lg-6 m-auto text-center text-lg-right aos-init aos-animate" data-aos="fade-left">
                                        <div class="img-holder md-mt-50 d-inline-block"><img src="/main/images/hotel4.png" alt="Team’s Schedule With TaskFlier"/></div>
                                    </div>
                                </div>
                            </div>
                        </div>
          
                        <div className="faq-classic pt-120 md-pt-120 bg-white">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="title-style-one mb-40">
                                            <h6 className="font-rubik">Find your answers</h6>
                                            <h2>Have any thought? Look here.</h2>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div id="accordion" className="md-mt-60">
                                            <div className="card">
                                                <div className="card-header" id="headingOne">
                                                    <h5 className="mb-0">
                                                        <button
                                                            className="btn btn-link"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#collapseOne"
                                                            aria-expanded="true"
                                                            aria-controls="collapseOne"
                                                        >
                                                           What type of hospitality businesses can use TaskFlier?
                                                        </button>
                                                    </h5>
                                                </div>
                                                <div
                                                    id="collapseOne"
                                                    className="accordion-collapse collapse show"
                                                    data-bs-parent="#accordion"
                                                >
                                                    <div className="card-body">
                                                        <p>
                                                           TaskFlier is ideal for hotels, resorts, serviced apartments, guest houses, banquet halls, and multi-property hospitality chains. It adapts to both small teams and large operations.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card">
                                                <div className="card-header" id="headingTwo">
                                                    <h5 className="mb-0">
                                                        <button
                                                            className="btn btn-link"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#collapseTwo"
                                                            aria-expanded="true"
                                                            aria-controls="collapseTwo"
                                                        >
                                                           How does TaskFlier improve guest satisfaction?
                                                        </button>
                                                    </h5>
                                                </div>
                                                <div
                                                    id="collapseTwo"
                                                    className="accordion-collapse collapse "
                                                    data-bs-parent="#accordion"
                                                >
                                                    <div className="card-body">
                                                        <p>
                                                           TaskFlier reduces service delays by converting guest requests into real-time tasks. Faster responses, better coordination, and consistent service standards lead to happier guests and better reviews.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card">
                                                <div className="card-header" id="headingThree">
                                                    <h5 className="mb-0">
                                                        <button
                                                            className="btn btn-link"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#collapseThree"
                                                            aria-expanded="true"
                                                            aria-controls="collapseThree"
                                                        >
                                                            Can TaskFlier manage multiple departments at once?
                                                        </button>
                                                    </h5>
                                                </div>
                                                <div
                                                    id="collapseThree"
                                                    className="accordion-collapse collapse"
                                                    data-bs-parent="#accordion"
                                                >
                                                    <div className="card-body">
          
                                                        <p >Yes. TaskFlier connects front desk, housekeeping, maintenance, events, and management on one platform, ensuring smooth coordination and complete operational visibility.</p>
          
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card">
                                                <div className="card-header" id="headingFour">
                                                    <h5 className="mb-0">
                                                        <button
                                                            className="btn btn-link"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#collapseFour"
                                                            aria-expanded="true"
                                                            aria-controls="collapseFour"
                                                        >
                                                           Is TaskFlier suitable for multi-property hotels?
          
                                                        </button>
                                                    </h5>
                                                </div>
                                                <div
                                                    id="collapseFour"
                                                    className="accordion-collapse collapse "
                                                    data-bs-parent="#accordion"
                                                >
                                                    <div className="card-body">
                                                        <p>Absolutely. TaskFlier allows centralized control of multiple properties while maintaining separate teams, workflows, and reports for each location.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card">
                                                <div className="card-header" id="headingFive">
                                                    <h5 className="mb-0">
                                                        <button
                                                            className="btn btn-link"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#collapseFive"
                                                            aria-expanded="true"
                                                            aria-controls="collapseFive"
                                                        >
                                                           How secure is TaskFlier for hospitality data?
                                                        </button>
                                                    </h5>
                                                </div>
                                                <div
                                                    id="collapseFive"
                                                    className="accordion-collapse collapse "
                                                    data-bs-parent="#accordion"
                                                >
                                                    <div className="card-body">
                                                        <p>
                                                           TaskFlier is cloud-based with role-based access controls, ensuring sensitive guest and operational data remains secure while being accessible to authorized staff anytime.</p>
                                                    </div>
                                                </div>
                                            </div>
          
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
    </>
  )
}

export default Hospitality